// Settings mutations
import types from '../../types';

export default {
  // shops
  [types.STORE_SHOPS]: (state, payload) => {
    state.shops.items = payload.items;
    state.shops.count = payload.count;
    state.shops.entity = payload.entity;
  },
  // [types.STORE_SHOP]: (state, payload) => {
  //   state.shop = payload;
  // },

  // shipping methods
  [types.STORE_SHIPPING_METHODS]: (state, payload) => {
    state.shippingMethods.items = payload.items;
    state.shippingMethods.count = payload.count;
    state.shippingMethods.entity = payload.entity;
  },
  // [types.STORE_SHIPPING_METHOD]: (state, payload) => {
  //   state.shippingMethod = payload;
  // },
};
